<template>
    <div class="login">
        <div class="background">
            <div class="backgroundimg" :style="height">
                <img src="../../assets/images/login/icon02.jpg" alt="">
            </div>
            <div class="background-text">
                <span class="">
                    天无信，四时失序
                </span>
                <span>
                    人有信，行止可立
                </span>
            </div>
        </div>
        <div class="main">
            <div class="title">意健险—后台管理系统</div>
            <div class="sect">
                <div class="sect-tit">
                    管理者登录
                </div>
                <div class="item">
                    <!-- <div class="item-tit">账户名:</div> -->
                    <div class="input">
                        <el-input prefix-icon="el-icon-user-solid" v-model="signInData.phone" placeholder="请输入账户名"></el-input>
                    </div>
                </div>
                <div class="item">
                    <!-- <div class="item-tit">密码:</div> -->
                    <div class="input">
                        <el-input prefix-icon="el-icon-unlock" v-model="signInData.password" placeholder="请输入密码" type="password"></el-input>
                    </div>
                </div>
                <el-button type="primary" class="btn" @click="signIn">登录</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../api/login'
export default {
    name: 'login',
    data () {
        return {
            height:'',
            signInData:{
            },
        }
    },
    created(){
        

    },
    mounted(){
        this.getHeight();
    },
    methods:{
         //获取浏览器的当前的高度
        getHeight(){
            let _this = this;
            _this.height =  'height:'+document.body.clientHeight+'px';
            window.onresize = function(){
                _this.height =  'height:'+document.body.clientHeight+'px';
                console.log(_this.height);
                // 是否全屏
                // if(!_this.isFullScreen){
                //     _this.isFullScreen=true;
                // }
            }
        },
        async signIn() {
            let data = await api.signIn(this.signInData);
            if(data.data.code == '200') {
                localStorage.setItem('accessToken', data.data.data.token);
                localStorage.setItem('name', data.data.data.name);
                localStorage.setItem('mechanismid', data.data.data.mechanismid);
                localStorage.setItem('mechanism', data.data.data.mechanism);
                localStorage.setItem('primaryToken', data.data.data);
                localStorage.setItem('roleStr', JSON.stringify(data.data.data.roles));
                this.$router.push({ path:'/main' });
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .login{
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        overflow: hidden;
        position:relative;
        .background{
            position:relative;
            overflow: hidden;
            height: 100%;
            flex: 1;
            .backgroundimg{
                overflow: hidden;
                img{
                    width: 100%;
                    // height: 100%;
                    // min-width: 1533px;
                    // min-height: 1000px;
                    min-width: 1500px;
                    // height: 1000px;
                }
            }
            .background-text{
                position: absolute;
                top: 320px;
                left: 70px;
                color: #ffffff;
                display: flex;
                flex-direction: column;
                font-size: 88px;
                line-height: 110px;
                font-weight: bold;
            }
        }
        .main{
            width: 466px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                font-size: 32px;
                color: #0f85ff;
                text-align: center;
                margin-bottom: 20px;
                font-weight: bold;
            }
            .sect{
                // background-color: rgba(255, 255, 255, 0.4);
                border-radius: 10px;
                .sect-tit{
                    font-size: 20px;
                    text-align: center;
                    color: #0f85ff;
                    font-weight: bold;
                    letter-spacing:5px;
                    display: flex;
                    justify-content: space-around;
                    margin-bottom: 30px;
                    .t-item{
                        color: #ffffff;
                        cursor: pointer;
                    }
                    .t-item-this{
                        color: #1250ea;
                        border-bottom: 2px solid #1250ea;
                        
                        padding-bottom: 10px;
                        
                    }
                }
                .item{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 15px;
                    .item-tit{
                        font-size: 18px;
                        margin-left: 3px;
                    }
                    .input{
                        width: 350px;
                    }
                }
                .btn{
                    width: 350px;
                    margin-bottom: 10px;
                    font-weight: bold;
                }
            }
        }
    }
  
</style>
